var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"catalog-skeleton"},[_c('div',{staticClass:"catalog-skeleton__tabs"},_vm._l((4),function(i){return _c('v-skeleton-loader',{key:i,staticClass:"catalog-skeleton__chip",attrs:{"type":"chip","height":"48"}})}),1),_c('VariantsSkeletonLoader')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }